export function deepMerge(target, source) {
    const returnType = (target || {});
    for (const key in source) {
        if (source[key] instanceof Object)
            Object.assign(source[key], deepMerge(returnType[key], source[key]));
    }
    Object.assign(returnType || {}, source);
    return returnType;
}
//# sourceMappingURL=sitUtils.js.map